module.exports = __webpack_public_path__ + "img/Facebook.36f7f006.png";